import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/stage1-result/bg.png'
import nextBtnImage from '../assets/images/stage1-result/next.png';

class Stage1Result extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
    }
    
    nextBtnClick() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './stage2-intro',
            state: {
                distance: this.props.location.state.distance,
                score: this.props.location.state.score
            }
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <div style={{ position: 'absolute', right: '39.5%', top: '45%', width: '10%', height: '10%', color: '#086940' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#152b85" >{this.props.location.state.distance}</text>
                    </svg>
                </div>
                <div style={{ position: 'absolute', right: '41.5%', top: '60%', width: '10%', height: '10%', color: 'white' }}>
                    <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                        <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#152b85" >{this.props.location.state.score}</text>
                    </svg>
                </div>
                <img className='press-btn' alt='' src={nextBtnImage} style={{ height: '12%', bottom: '4%', left: '38.5%', position: 'absolute', background: 'transparent' }} onClick={this.nextBtnClick.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Stage1Result);
